import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import { a as patchEsm, b as bootstrapLazy } from './index-9ee0fd85.js';

var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window !== 'undefined') {
    return patchEsm().then(function () {
      bootstrapLazy([["publicbadges-circle_3", [[1, "publicbadges-drawer", {
        "badgeColor": [1, "badge-color"],
        "modalTheme": [1, "modal-theme"],
        "testMode": [4, "test-mode"],
        "isOpen": [32],
        "modalOrientation": [32],
        "modalLeft": [32],
        "modalOrigin": [32],
        "badges": [32]
      }, [[8, "keydown", "handleKeyDown"], [0, "closeDrawer", "closeDrawer"], [9, "resize", "handleWindowResize"]]], [0, "publicbadges-modal", {
        "theme": [1],
        "mode": [1],
        "left": [2],
        "origin": [1],
        "badges": [16],
        "openBadge": [32]
      }], [0, "publicbadges-circle", {
        "badgesCount": [2, "badges-count"],
        "interactive": [4],
        "testMode": [4, "test-mode"]
      }]]]], options);
    });
  }

  return Promise.resolve();
};

export { defineCustomElements };